import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../utils/apiErrorHandling';
import useSnackbar from '../hooks/useSnackbar';
import Snackbar from '../components/Snackbar';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { snackbar, showSnackbar, closeSnackbar } = useSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      showSnackbar('아이디와 비밀번호를 입력해주세요.', 'error');
      return;
    }

    setLoading(true);

    try {
      const response = await apiClient.post('/auth/login', { username, password });
      
      console.log('로그인 응답:', response.data);
      
      // 토큰 저장
      const token = response.data.access_token || response.data.token;
      if (token) {
        localStorage.setItem('authToken', token);
        
        // 토큰 만료 시간 저장 (24시간 후)
        const expiresAt = Date.now() + (24 * 60 * 60 * 1000);
        localStorage.setItem('tokenExpiresAt', expiresAt.toString());
        
        console.log('토큰 저장 완료, 만료 시간:', new Date(expiresAt));
      }

      // 사용자 정보 저장 (선택사항)
      if (response.data.user) {
        localStorage.setItem('userInfo', JSON.stringify(response.data.user));
        console.log('사용자 정보:', response.data.user);
      }

      showSnackbar(response.data.message || '로그인 성공!', 'success');
      setLoading(false);
      
      // products 페이지로 이동
      setTimeout(() => {
        navigate('/products');
      }, 500);
    } catch (error) {
      console.error('로그인 에러:', error);
      showSnackbar(error.response?.data?.message || '로그인에 실패했습니다.', 'error');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-lg shadow-xl p-8">
          {/* 로고/타이틀 영역 */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">
              CST Product Manager
            </h1>
            <p className="text-gray-600">
              관리자 로그인
            </p>
          </div>

          {/* 로그인 폼 */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* 아이디 입력 */}
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
                아이디
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                placeholder="아이디를 입력하세요"
                disabled={loading}
              />
            </div>

            {/* 비밀번호 입력 */}
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                비밀번호
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                placeholder="비밀번호를 입력하세요"
                disabled={loading}
              />
            </div>

            {/* 로그인 버튼 */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {loading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  로그인 중...
                </>
              ) : (
                '로그인'
              )}
            </button>
          </form>

          {/* 디버깅 정보 (개발 모드에서만) */}
          {process.env.NODE_ENV === 'development' && (
            <div className="mt-6 p-4 bg-gray-50 rounded-lg text-xs text-gray-600">
              <p className="font-semibold mb-2">디버깅 정보:</p>
              <p>API URL: {process.env.REACT_APP_API_URL || 'http://localhost:8000'}</p>
            </div>
          )}
        </div>

        {/* 스낵바 */}
        <Snackbar
          isOpen={snackbar.isOpen}
          message={snackbar.message}
          type={snackbar.type}
          onClose={closeSnackbar}
        />
      </div>
    </div>
  );
};

export default Login;

